import { render, staticRenderFns } from "./UpdateClassroom.vue?vue&type=template&id=88194a3a"
import script from "./UpdateClassroom.vue?vue&type=script&lang=js"
export * from "./UpdateClassroom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports